<template>
  <main class="mt-5">
    <span id="add-btn">
      <button
        type="button"
        class="btn btn-success"
        :disabled="!hasPermission('write_customer') || disabled"
        @click="newAction"
      >
        عملیات جدید
      </button>
    </span>

    <b-tooltip
      v-if="!hasPermission('write_customer')"
      target="add-btn"
      triggers="hover"
    >
      شما به این بخش دسترسی ندارید
    </b-tooltip>

    <div class="card mt-3">
      <div
        class="card-header border-0 d-flex justify-content-between align-items-center mb-1"
      >
        <h5 class="card-title font-bold mb-0">عملیات‌ها</h5>
      </div>

      <div class="card-body position-relative">
        <b-table
          responsive
          hover
          bordered
          show-empty
          empty-text="موردی یافت نشد"
          :busy="show"
          :items="tableItems"
          :fields="fields"
        >
          <template v-slot:cell(level)="data">
            {{ getLevelTitle(data.item) }}
          </template>

          <template v-slot:cell(type)="data">
            {{ getTypeLabel(data.item.type) }}
          </template>

          <template v-slot:cell(type_value)="data">
            {{ formatTypeValue(data.item) }}
          </template>

          <template v-slot:cell(start_date)="data">
            {{ data.item.start_date | persianDate }}
          </template>

          <template v-slot:cell(end_date)="data">
            {{ data.item.end_date | persianDate }}
          </template>

          <template v-slot:cell(created_at)="data">
            {{ data.item.created_at | persianDate }}
          </template>

          <template v-slot:cell(show)="data">
            <router-link
              :to="{ name: 'action.show', params: { id: data.item.id } }"
              class="action-btns1  pt-1 px-2"
            >
              <i class="fe fe-eye  text-info"></i>
            </router-link>
          </template>
          <template v-slot:cell(edit)="data">
            <span :id="'edit-btn-' + data.item.id">
              <a
                class="action-btns1 pt-1 px-2"
                :class="{ 'disabled-link': !hasPermission('modify_customer') }"
                @click="openEditEndDate(data.item)"
              >
                <i class="feather feather-edit text-primary"></i>
              </a>
            </span>

            <b-tooltip
              v-if="!hasPermission('modify_customer')"
              :target="'edit-btn-' + data.item.id"
              triggers="hover"
            >
              شما به این بخش دسترسی ندارید
            </b-tooltip>
          </template>
          <template v-slot:cell(delete)="data">
            <span :id="'delete-btn-' + data.item.id">
              <a
                :disabled="!hasPermission('delete_customer') ? true : false"
                class="action-btns1 pt-1 px-2"
                @click="deleteItem(data.item.id)"
              >
                <i class="feather feather-trash-2 text-danger"></i>
              </a>
            </span>

            <b-tooltip
              v-if="!hasPermission('delete_customer')"
              :target="'delete-btn-' + data.item.id"
              triggers="hover"
            >
              شما به این بخش دسترسی ندارید
            </b-tooltip>
          </template>
        </b-table>

        <Loading
          v-if="show || !items || $root.isEmptyObject(items)"
          class="loading-class"
        />

        <pagination
          v-if="hasRows"
          :limit="2"
          :disabled="disabled"
          :data="items"
          @pagination-change-page="changePage"
        />
      </div>
    </div>

    <action-modal
      :mode="mode"
      :main-data="action"
      :url="submit_url"
      :levels="levels"
      @saved="handleSaved"
    />
    <b-modal
      v-model="editModal"
      title="ویرایش تاریخ پایان"
      ok-title="ذخیره"
      cancel-title="انصراف"
      :ok-disabled="editLoading"
      @ok.prevent="submitEndDate"
    >
      <span>در صورت گذشتن تاریخ پایان آن را نمی توانید تغییر بدید</span>
      <b-form-group>
        <label for="end_date">تاریخ پایان</label>

        <date-picker
          v-model="editForm.end_date"
          type="datetime"
          format="YYYY-MM-DD HH:mm"
          display-format="jYYYY-jMM-jDD HH:mm"
          placeholder="تاریخ پایان"
        />
        <small v-if="editError" class="text-danger d-block mt-1">{{
          editError
        }}</small>
      </b-form-group>
    </b-modal>
  </main>
</template>

<script>
import ActionImpl from "@@/core/pages/Action/ActionImpl";

export default {
  extends: ActionImpl,
};
</script>

<style scoped>
.disabled-link {
  cursor: not-allowed;
  opacity: 0.45;
  pointer-events: none;
}
.loading-class {
  z-index: 10;
  position: absolute;
  top: 70px;
  right: 50%;
  transform: translateX(50%);
  scale: 1.5;
}

.action-btns1:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}
</style>
